import { useRef, useEffect } from "react";

const IsMounted = () => {
  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, [isMounted]);

  return isMounted;
};

export default IsMounted;
